module.exports = __webpack_public_path__ + "img/Jerk Sandwich-Vegetarian_.fd639ba4.jpg";